<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template #header>
      <div class="table-header">
        List of Users

        <router-link to="/users/add">
          <button class="btn btn-primary">Add user</button>
        </router-link>
      </div>
    </template>

    <div class="row ">
      <DataTable
        :value="tickets"
        :lazy="true"
        :paginator="true"
        class="p-datatable-customers card p-2"
        :rows="per_page"
        :totalRecords="totalRows"
        @page="onPage($event)"
        @sort="onSort($event)"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 25, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <template #empty> No record found. </template>
        <template #loading> Loading data. Please wait. </template>
        <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
        <Column field="id"  header="ID" sortable>ID</Column>
        <Column field="title"  header="title" sortable></Column>
        <Column field="category.name"  header="name" sortable></Column>
        <Column  header="date" sortField="created_at" filterField="created_at">    
          <template #body="slotProps">

          {{ new Date(slotProps.data.created_at).toLocaleDateString() }}

</template>
                                   </Column>
        <Column field="content"  header="content" sortable></Column>
      
        <Column field="author_name"  header="user" sortable></Column>
        <Column field="author_email"  header="user_email" sortable></Column>
        <Column field="priority"  header="priority" sortable></Column>
        <Column field="status"  header="status" sortable></Column>
        <Column header="action">
          <template #body="slotProps">

            <router-link :to="'/support/view-ticket/'+slotProps.data.id">
    <i class="far fa-eye text-primary action"></i>
</router-link>


</template>
              </Column>
      </DataTable>

      
    </div>
  </Layout>
</template>

<script>
// import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import ApiClass from "../../api/api";

import Swal from "sweetalert2";

import PageHeader from "@/components/page-header";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
// import ColumnGroup from 'primevue/columngroup';
// import InputText from "primevue/inputtext";
// import MultiSelect from 'primevue/multiselect';
// import Dropdown from "primevue/dropdown";

// import Calendar from "primevue/calendar";
// import ProgressBar from 'primevue/progressbar';

export default {
  components: {
    Layout,
    PageHeader,
    DataTable,
    // Dropdown,
    // Calendar,
    Column,
    // InputText,
  },
  data() {
    return {
      totalRows: 1,
      per_page: 10,
      page: 1,
      disable_status: null,
      title: "Ticket List",
      items: [
        {
          text: "Support",
          href: "/support/category",
        },
        {
          text: "Ticket List",
          active: true,
        },
      ],
      filters: {
        name: null,
        email: null,
        // mobile: null,
        date: null,
        status: null,
        duration: null,
      },
      filter: "",
      tickets: [],
      loading: true,
      statuses: ["verified", "unverified"],
      actionss: ["enabled", "disabled"],
      duration: ["day", "week", "month"],
    };
  },

  mounted() {
    this.getTickets();
  },

  methods: {
    showSwalf(id, status) {
      // alert('id= '+ id + 'disable_status='+ this.disable_status +'status='+status)
      this.disable_status = status ? "Enable" : "Disable";
      this.$swal({
        title: "Please Confirm.",
        text: "Are you sure you want to " + this.disable_status + " action?",
        icon: "warning",
        iconColor: "#ff0000",
        showCancelButton: true,
        cancelButtonColor: "#ff0000",
        cancelButtonText: "No",
        confirmButtonColor: "#008000",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiHit(id, status);
        } else {
          this.getTickets();
        }
      });
    },
    async apiHit(id, status) {
      var res = await ApiClass.updateRequest(
        "admin/users/update_status/" + id + "/" + status,
        true
      );
      // console.log('resdddd=', res);

      if (res.data.status_code == 1) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: res.data.message,
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: res.data.message,
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    async getTickets() {
      await ApiClass.getRequest(
        "admin/ticket/get?per_page=" +
          this.per_page +
          "&page=" +
          this.page +
          "&" +
          this.filter
      ).then((res) => {
         console.log("result=", res.data.data);
        if (res.data.status_code == 1) {
          this.loading = false;
          this.tickets = res.data.data.data;
          this.currentPage = res.data.data.current_page;
          this.totalRows = res.data.data.total;
        }
      });
    },

    onPage(event) {
      if (this.page != event.page + 1) {
        this.loading = !this.loading;
        this.page = event.page + 1;
        this.getTickets();
      }
    },

    onSort(e) {
      this.loading = !this.loading;
      var sortby = e.sortOrder == 1 ? "asc" : "desc";
      this.filter = "sortby=" + sortby + "&sortbyname=" + e.sortField;
      this.getTickets();
    },

    topFilter(columnVal, columnName) {
      //  if(columnName == 'status'){

      //          columnVal = columnVal == 'verified' ? true : false;
      //      }
      if (columnName == "date") {
        columnVal = columnVal.toLocaleDateString("es-US").split("T")[0];
        columnVal = columnVal.replaceAll("/", "-");

        columnVal = columnVal
          .split("-")
          .reverse()
          .join("-");
      }
      this.loading = !this.loading;

      this.$set(this.filters, columnName, columnVal);

      var x = this.filters;
      const resulted = JSON.parse(JSON.stringify(x), (key, value) =>
        value === null || value === "" ? undefined : value
      );

      let query = new URLSearchParams(resulted).toString();

      this.filter = query;

      this.getTickets();
    },
  },
};
</script>

<style lang="scss">
.p-paginator {
  .p-paginator-current {
    margin-left: auto;
  }
}

.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #00acad;
  }
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable .p-datatable-thead > tr > th,
.p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  padding: 10px;
}
/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 64em) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        border: 0 none !important;
        width: 100% !important;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4rem 1rem -0.4rem -0.4rem;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
